<template>
  <div id="home">
    <router-view />
  </div>
</template>
<script>
import { setLegacyTheme } from '@/utils/order-theme'
import { showDialog } from 'vant';
import { mapMutations, mapGetters } from 'vuex'
// 公共方法
import { getUrlParams } from '../../utils/const'
export default {
  name: 'home',
  data () {
    return {
      params: {},
      isRuiZe: process.env.VUE_APP_RUIZE_CLIENT_ID, // 是否是睿择
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'theme', 'orderDetail', 'urlParams', 'deviceType', 'endInquiry'])
  },
  mounted () {
    this.getUrlParams()
    this.getCache(() => {
      // 睿择渠道设置主题
      if (this.isRuiZe === this.userInfo.clientID) {
        setLegacyTheme(this.theme);
      }
    })
  },
  methods: {
    getCache (callback) {
      if (JSON.stringify(this.params) === '{}') return
      if (!this.params.orderID || !this.urlParams.token) return
      let params = this.params
      this.$_http.get(this.$_API.H5_INQUIRY_CENTER_GET_CACHE, { params }).then(res => {
        if (res.data.orderStatus === 0 || res.data.orderStatus === 1) {
          this['user/updateOrderDetail']({
            orderID: res.data.inquiryOrderID,
            userSig: res.data.userSig,
            userID: res.data.userID,
            orderPatientID: res.data.orderPatientID,
            ...this.orderDetail
          })
          this['global/updateStep'](1)
        }

        let configVoList = res.data.appConfigVoList
        if (Array.isArray(configVoList)) {
          configVoList.map((item) => {
            if (item.configKey === 'HUAFU_UI' && item.configValue === '1') {
              this['global/updateHuafuUI'](1)
              window.postMessage(
                {
                  data: {
                    action: 'huafuYB'
                  }
                },
                '*'
              )
            }
          })
        }

        this['user/updateOrderDetail']({ orderID: res.data.inquiryOrderID, ...res.data, ...this.orderDetail })
        if (res.success) {
          // console.log(res.data)
          this.params = res.data
          this.routerPush(res.data)
          callback && callback()
        }
      })
    },
    routerPush (data) {
      this['user/updateUserInfo']({
        orderStatus: data.orderStatus,
        ...this.params
      })
      if (this.urlParams.type) {
        this.$router.replace({
          path: '/autoVideo',
          query: {
            ...this.urlParams
          }
        })
        return
      }
      if (data.inquiryStatus === 0) {
        this.$router.replace({
          path: '/patientDetail',
          query: {
            ...this.urlParams
          }
        })
      } else if (data.inquiryStatus === 1) {
        this.$router.replace({
          path: '/waiting',
          query: {
            ...this.urlParams
          }
        })
      } else if (data.inquiryStatus === 2 || data.inquiryStatus === 3 || data.inquiryStatus === 4) {
        if (data.inquiryType === 1) {
          this.$router.replace({
            path: '/consultation',
            query: {
              ...this.urlParams
            }
          })
        }
        if (data.inquiryType === 2) {
          this.$router.replace({
            path: '/trtcCalling',
            query: {
              ...this.urlParams
            }
          })
        }
        if (data.inquiryType === 3) {
          this.$router.replace({
            path: '/videoPage',
            query: {
              ...this.urlParams
            }
          })
        }
      } else {
        showDialog({
          message: '订单已取消，请退出重试',
          confirmButtonText: '确定',
          className: 'dialog-css',
          confirmButtonColor: '#438BEF',
          closeOnClickOverlay: true
        }).then(() => {
          this.goBack();
        })
      }
    },
    goBack () {
      const deviceType = this.deviceType || getUrlParams()['deviceType']
      if (deviceType === 'wechat') {
        wx.miniProgram.navigateBack({
          delta: history.length
        });
      } else if (deviceType === 'uniapp') {
        window.postMessage({
          data: {
            action: 'popstate'
          }
        }, '*')
        uni.postMessage({
          data: {
            action: 'popstate'
          }
        })
      } else {
        this.$router.back()
      // history.go(-(history.length - 2));
      }
    },
    getUrlParams (callback) {
      if (this.$route.name === 'rpViewer' || this.$route.name === 'autoVideo') return
      let obj = this.$route.query
      this.params = obj
      if (!obj['token']) {
        showDialog({
          message: '参数缺失，请重新进入',
          confirmButtonText: '确定',
          confirmButtonColor: '#438BEF',
          closeOnClickOverlay: true
        })
        this.goBack()
      }
      this['global/updateDeviceType'](obj.deviceType)
      this['global/updateUrlParams'](obj)
    },
    ...mapMutations([
      'global/updateMask',
      'global/updateStep',
      'global/updateHuafuUI',
      'global/updateUrlParams',
      'user/updateOrderDetail',
      'global/updateDeviceType',
      'global/updateEndInquiry',
      'user/updateUserInfo',
      'user/updateImInfo'
    ])
  },
  destroyed () { }
};
</script>
<style scoped>
#home {
  height: 100vh;
  width: 100vw;
}
</style>
<style lang="scss">
@import '../patientDetail/chaoneng.scss';
</style>
